import { combineReducers } from 'redux';
import { authReducer } from '../../auth/login/redux/reducers';
import { statsReducer } from '../../main/main-content/dashboard/redux/reducers';
import { rulesReducer } from '../../main/main-content/modify-rules/redux/rules.reducer';
import { alertsReducer } from '../../main/main-content/alerts/list/redux/reducers';
import { playersReducer } from '../../main/main-content/players/redux/reducers';
import { playerReducer } from '../../main/main-content/players/player-details/content/redux/reducers';
import { dismissAlertReducer } from '../../main/main-content/alerts/dismiss/redux/reducers';
import { eventsReducer } from '../../main/main-content/risk-assessment/redux/events/reducers';
import { riskReducer } from '../../main/main-content/risk-assessment/redux/risk/risk.reducer';
import { updateRiskReducer } from '../../main/main-content/risk-assessment/redux/risk/update-risk.reducer';
import { updateRuleReducer } from '../../main/main-content/modify-rules/redux/update-rule.reducer';
import { jurisdictionReducer } from '../../jurisdiction/redux/reducers';
import { usersReducer } from '../../main/main-content/team/user/redux/user-reducer';
import { teamsReducer } from '../../main/main-content/team/teams/redux/team-reducer';
import {
    delegateAlertReducer,
    delegateTeamsReducer
} from '../../main/main-content/alerts/delegate/redux/reducers';
import { forgotPasswordReducer } from '../../auth/reset-password/redux/reducers';
import { helpReducer } from '../../main/main-content/help/redux/reducers';
import { exportCsvReducer } from '../../main/main-content/export-csv/redux/reducers';
import { clientCredentialsReducer } from '../../main/main-content/client-access/redux/reducer';
import { auditReducer } from '../../main/main-content/audit/redux/reducer';
import { simulationReducer } from '../../main/main-content/simulation/redux/simulation-reducer';

export default combineReducers({
    authentication: authReducer,
    forgotPassword: forgotPasswordReducer,
    jurisdiction: jurisdictionReducer,
    rules: rulesReducer,
    updateRule: updateRuleReducer,
    stats: statsReducer,
    alerts: alertsReducer,
    dismissAlert: dismissAlertReducer,
    delegateAlert: delegateAlertReducer,
    delegateTeams: delegateTeamsReducer,
    events: eventsReducer,
    risk: riskReducer,
    updateRisk: updateRiskReducer,
    players: playersReducer,
    player: playerReducer,
    teams: teamsReducer,
    users: usersReducer,
    help: helpReducer,
    exportCsv: exportCsvReducer,
    simulation: simulationReducer,
    clientCredentials: clientCredentialsReducer,
    audit: auditReducer
});
